<template>
  <div class="suggest-field">
    <label class="field-label">
      {{ label }}
      <span v-if="required" class="u-color-danger"> *</span>
    </label>
    <div>
      <vue-simple-suggest
        v-model="localValue"
        :destyled="true"
        :styles="autoCompleteStyle"
        :list="suggestionList"
        :display-attribute="displayAttribute"
        :required="required">
      </vue-simple-suggest>
      <PublishBadge v-if="isPublish" class="publish-badge"></PublishBadge>
    </div>
    <div class="error-message">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script lang="babel">
import VueSimpleSuggest from 'vue-simple-suggest';
import PublishBadge from "@/components/PublishBadge";

export default {
  name: "SuggestField",
  components: { VueSimpleSuggest, PublishBadge },
  data() {
    return {
      autoCompleteStyle: {
        defaultInput: 'suggestion-input'
      }
    }
  },
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      required: false
    },
    required: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      required: false
    },
    suggestionList: {
      required: false
    },
    displayAttribute: {
      type: String,
      required: false
    },
    isPublish: {
      type: Boolean,
      required: false
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.suggest-field {
  position: relative;
}

.field-label {
  color: #CAC9C9;
}

::v-deep .vue-simple-suggest {
  .input-wrapper {
    input::placeholder {
      color: #CAC9C9;
    }

    input {
      box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
      border: none;
      letter-spacing: 0.03rem;
      outline: none;
      height: 42px;
      width: 100%;
      -webkit-appearance: none;
      border-radius: 1px;
      appearance: none;
    }

    input:focus {
      box-shadow: 0 2px 0 #F94848;
    }
  }

  .suggest-item {
    padding: 10px 0;
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
}

.error-message {
  padding-top: 7px;
  padding-bottom: 7px;

  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: .03em;
  color: #f14848;
  height: 40px;
}

.publish-badge {
  font-size: 10px;
  position: absolute;
  right: 5px;
  top: 30px;
  background-color: white;
}
</style>
